"use client";
import Link from "next/link";
import { getPageVisibilityClass, LogoVariant } from "../../design1/Footer";
import { FOOTER_NAV_LINKS } from "src/app/components/constants/navlink";
import React from "react";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { useFetchValidSocialMediaLinks } from "src/app/lib/useFetcchValidSocialMediaLinks";
import { usePathname } from "next/navigation";
import { CompanyLogo } from "../../design1/NavBar";
import { Config } from "src/types";
import { usePagesWithBranchQuery } from "src/app/hooks/useBranchFirst";

export const useIsHome = () => {
  const pathname = usePathname();
  return pathname === "/";
};

const FacebookIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="white" />
      <path
        d="M16.5 4.50195H14.25C13.2554 4.50195 12.3016 4.89704 11.5983 5.6003C10.8951 6.30356 10.5 7.25739 10.5 8.25195V10.502H8.25V13.502H10.5V19.502H13.5V13.502H15.75L16.5 10.502H13.5V8.25195C13.5 8.05304 13.579 7.86227 13.7197 7.72162C13.8603 7.58097 14.0511 7.50195 14.25 7.50195H16.5V4.50195Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const InstagramIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="white" />
      <path
        d="M15.125 5.75H8.875C7.14911 5.75 5.75 7.14911 5.75 8.875V15.125C5.75 16.8509 7.14911 18.25 8.875 18.25H15.125C16.8509 18.25 18.25 16.8509 18.25 15.125V8.875C18.25 7.14911 16.8509 5.75 15.125 5.75Z"
        fill="var(--primary-color)"
      />
      <path
        d="M14.5003 11.606C14.5774 12.1261 14.4886 12.6573 14.2464 13.1241C14.0042 13.5908 13.621 13.9693 13.1513 14.2057C12.6816 14.4422 12.1493 14.5244 11.6302 14.4409C11.111 14.3574 10.6314 14.1123 10.2596 13.7404C9.88775 13.3686 9.64264 12.889 9.5591 12.3698C9.47556 11.8507 9.55785 11.3184 9.79426 10.8487C10.0307 10.379 10.4092 9.99579 10.8759 9.7536C11.3427 9.51141 11.8739 9.42257 12.3941 9.4997C12.9246 9.57838 13.4158 9.82561 13.7951 10.2049C14.1744 10.5842 14.4216 11.0754 14.5003 11.606Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4375 8.5625H15.445"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const YoutubeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="white" />
      <path
        d="M18.5879 8.5125C18.5136 8.21588 18.3624 7.94411 18.1495 7.72463C17.9366 7.50515 17.6696 7.34574 17.3754 7.2625C16.3004 7 12.0004 7 12.0004 7C12.0004 7 7.70036 7 6.62536 7.2875C6.33114 7.37074 6.06409 7.53015 5.8512 7.74963C5.6383 7.96911 5.4871 8.24088 5.41286 8.5375C5.21612 9.62847 5.11988 10.7352 5.12536 11.8437C5.11834 12.9607 5.21459 14.0758 5.41286 15.175C5.49471 15.4624 5.6493 15.7238 5.8617 15.934C6.0741 16.1443 6.33712 16.2961 6.62536 16.375C7.70036 16.6625 12.0004 16.6625 12.0004 16.6625C12.0004 16.6625 16.3004 16.6625 17.3754 16.375C17.6696 16.2918 17.9366 16.1323 18.1495 15.9129C18.3624 15.6934 18.5136 15.4216 18.5879 15.125C18.7831 14.0422 18.8793 12.944 18.8754 11.8437C18.8824 10.7268 18.7861 9.61169 18.5879 8.5125Z"
        fill="var(--primary-color)"
      />
      <path
        d="M10.5938 13.8883L14.1875 11.8445L10.5938 9.80078V13.8883Z"
        fill="white"
      />
    </svg>
  );
};
const LinkedinIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="white" />
      <path
        d="M14.5 9.5C15.4946 9.5 16.4484 9.89509 17.1517 10.5983C17.8549 11.3016 18.25 12.2554 18.25 13.25V17.625H15.75V13.25C15.75 12.9185 15.6183 12.6005 15.3839 12.3661C15.1495 12.1317 14.8315 12 14.5 12C14.1685 12 13.8505 12.1317 13.6161 12.3661C13.3817 12.6005 13.25 12.9185 13.25 13.25V17.625H10.75V13.25C10.75 12.2554 11.1451 11.3016 11.8483 10.5983C12.5516 9.89509 13.5054 9.5 14.5 9.5Z"
        fill="var(--primary-color)"
      />
      <path
        d="M8.25 10.125H5.75V17.625H8.25V10.125Z"
        fill="var(--primary-color)"
      />
      <path
        d="M7 8.25C7.69036 8.25 8.25 7.69036 8.25 7C8.25 6.30964 7.69036 5.75 7 5.75C6.30964 5.75 5.75 6.30964 5.75 7C5.75 7.69036 6.30964 8.25 7 8.25Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const TwitterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="white" />
      <path
        d="M17.625 5.25H6.375C6.07663 5.25 5.79048 5.36853 5.5795 5.5795C5.36853 5.79048 5.25 6.07663 5.25 6.375V17.625C5.25 17.9234 5.36853 18.2095 5.5795 18.4205C5.79048 18.6315 6.07663 18.75 6.375 18.75H17.625C17.9234 18.75 18.2095 18.6315 18.4205 18.4205C18.6315 18.2095 18.75 17.9234 18.75 17.625V6.375C18.75 6.07663 18.6315 5.79048 18.4205 5.5795C18.2095 5.36853 17.9234 5.25 17.625 5.25ZM15.773 14.977C15.8252 15.0293 15.8667 15.0913 15.895 15.1596C15.9233 15.2279 15.9378 15.3011 15.9378 15.375C15.9378 15.4489 15.9233 15.5221 15.895 15.5904C15.8667 15.6587 15.8252 15.7207 15.773 15.773C15.7207 15.8252 15.6587 15.8667 15.5904 15.895C15.5221 15.9233 15.4489 15.9378 15.375 15.9378C15.3011 15.9378 15.2279 15.9233 15.1596 15.895C15.0913 15.8667 15.0293 15.8252 14.977 15.773L12 12.7952L9.02297 15.773C8.91742 15.8785 8.77427 15.9378 8.625 15.9378C8.47573 15.9378 8.33258 15.8785 8.22703 15.773C8.12148 15.6674 8.06219 15.5243 8.06219 15.375C8.06219 15.2257 8.12148 15.0826 8.22703 14.977L11.2048 12L8.22703 9.02297C8.12148 8.91742 8.06219 8.77427 8.06219 8.625C8.06219 8.47573 8.12148 8.33258 8.22703 8.22703C8.33258 8.12148 8.47573 8.06219 8.625 8.06219C8.77427 8.06219 8.91742 8.12148 9.02297 8.22703L12 11.2048L14.977 8.22703C15.0826 8.12148 15.2257 8.06219 15.375 8.06219C15.5243 8.06219 15.6674 8.12148 15.773 8.22703C15.8785 8.33258 15.9378 8.47573 15.9378 8.625C15.9378 8.77427 15.8785 8.91742 15.773 9.02297L12.7952 12L15.773 14.977Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const TikTokIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="white" />
      <path
        d="M15.0433 7.88C14.5877 7.35968 14.3366 6.6916 14.3367 6H12.2767V14.2667C12.2611 14.7141 12.0723 15.1381 11.7502 15.449C11.4281 15.7599 10.9977 15.9336 10.55 15.9333C9.60333 15.9333 8.81667 15.16 8.81667 14.2C8.81667 13.0533 9.92333 12.1933 11.0633 12.5467V10.44C8.76333 10.1333 6.75 11.92 6.75 14.2C6.75 16.42 8.59 18 10.5433 18C12.6367 18 14.3367 16.3 14.3367 14.2V10.0067C15.172 10.6066 16.1749 10.9284 17.2033 10.9267V8.86667C17.2033 8.86667 15.95 8.92667 15.0433 7.88Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

const icons = {
  facebook: <FacebookIcon />,
  instagram: <InstagramIcon />,
  linkedin: <LinkedinIcon />,
  x: <TwitterIcon />, // Twitter is now "X"
  youtube: <YoutubeIcon />,
  tiktok: <TikTokIcon />,
};

const Footer3 = () => {
  const isHome = useIsHome();
  const { data } = useFetchCompanyInfo();
  const alteredLinks = usePagesWithBranchQuery();
  // const highlightedPlatforms = ["youtube", "tiktok", "instagram"];
  const { socialMediaLinks } = useFetchValidSocialMediaLinks(icons);

  return (
    <footer
   
      id="footer"
      className=" text-white  z-[-10] max-w-full overflow-clip"
    >
      <div
        style={{
          backgroundImage: `linear-gradient(180.79deg, rgba(var(--primary-color-rgb), 0.3) 12.91%, rgba(var(--primary-color-rgb), 0.3) 41.45%, rgba(var(--primary-color-rgb), 0.3) 58.98%), url('/images/footer-image.webp')`,
          backgroundSize: "cover",
        }}
        className="id"
      >
        <div
          className={`first wrapper lg:flex-col ${
            isHome ? "pt-[11rem]" : "!pt-[7rem]"
          }  py-14 flex lg:gap-10 gap-[10%]`}
        >
          <div className="first relative -mt-14">
            <div className="bg-white w-max p-3 rounded-xl">
              <CompanyLogo />
            </div>

            <div className="second items-center mt-8 grid gap-4 gap-y-6 grid-cols-2">
              {socialMediaLinks?.map((item, index) => {
                return (
                  <Link
                    className="rounded-md flex items-center gap-3"
                    href={item.url}
                    key={index}
                  >
                    <span className={`rounded-md scale-110 w-max `}>
                      {item.icon}
                    </span>
                    <span className="capitalize">{item.name}</span>
                  </Link>
                );
              })}
            </div>
          </div>
          <div className="second flex xlg:flex-wrap  flex-1 flex-col gap-14">
            <div className="product-pages flex md:flex-col justify-between gap-8">
              <div className="product flex gap-4 flex-col">
                <BigHeader>Products</BigHeader>
                <div className="grid gap-2 grid-cols-1">
                  {FOOTER_NAV_LINKS.map((item, index) => {
                    return (
                      <ItemLink
                        className={getPageVisibilityClass(
                          item.url,
                          data as Config
                        )}
                        key={index}
                        href={item.url}
                      >
                        {item.name}
                      </ItemLink>
                    );
                  })}
                </div>
              </div>
              <div className="pages flex flex-col gap-4">
                <BigHeader>Pages</BigHeader>
                <div className="grid gap-2 grid-cols-1">
                  {alteredLinks.map((item, index) => {
                    return (
                      <ItemLink
                        className={getPageVisibilityClass(
                          item.url,
                          data as Config
                        )}
                        key={index}
                        href={item.url}
                      >
                        {item.name}
                      </ItemLink>
                    );
                  })}
                </div>
              </div>

              <div className="product flex gap-4 flex-col">
                <BigHeader>Contact</BigHeader>
                <div className="grid gap-2  grid-cols-1">
                  {Array.isArray(data?.companyInfo?.phone_number) && (
                    <IconFlex icon={<CallIcon />}>
                      <div className="grid grid-cols-2 gap-y-2 gap-4">
                        {Array.isArray(data?.companyInfo?.phone_number) &&
                        data.companyInfo.phone_number.length > 0 ? (
                          data.companyInfo.phone_number.map((item, index) => (
                            <Link
                              key={index}
                              href={`tel:${item}`}
                              className="hover:underline"
                              aria-label={`Call ${item}`}
                            >
                              {item}
                            </Link>
                          ))
                        ) : (
                          <p className="col-span-2 text-gray-500">
                            No phone numbers available
                          </p>
                        )}
                      </div>
                    </IconFlex>
                  )}

                  {data?.companyInfo?.head_office_address && (
                    <IconFlex icon={<LocationIcon />}>
                      <div className="line-clamp-2">
                        <div className="max-w-[280px]">
                          <Link
                            href={`https://maps.google.com/?q=${encodeURIComponent(
                              data?.companyInfo?.head_office_address
                            )}`}
                          >
                            {data?.companyInfo?.head_office_address}
                          </Link>
                        </div>
                      </div>
                    </IconFlex>
                  )}
                  {data?.companyInfo?.email && (
                    <IconFlex icon={<MessageIcon />}>
                      <Link href={`mailto:${data?.companyInfo?.email}`}>
                        {data?.companyInfo?.email}
                      </Link>
                    </IconFlex>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="all bg-white">
        <div className="second  text-themeColor items-center py-3 flex md:flex-col md:gap-5 justify-between wrapper z-[10]">
          <p
            className="truncate overflow-hidden whitespace-nowrap mx-4 md:mx-auto  xs:max-w-full "
            title={`${data?.companyInfo?.name}. All Rights Reserved.`}
          >
            © {data?.companyInfo?.name}. All Rights Reserved.
          </p>
          {data?.websiteSettings?.sponsored_logo && (
            <Link
              target={"_blank"}
              href="https://ourproperty.com.ng/"
              className="p  flex items-center text-[10px]"
            >
              <span className="inline-block text-[13px] mr-2">Powered By:</span>
              <LogoVariant />
              <div className="font-bold ml-1">Our Property NG</div>
            </Link>
          )}
        </div>
      </div>
    </footer>
  );
};
export default Footer3;

const ArrowIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 7.00039C15 6.17789 14.3225 5.50039 13.5 5.50039H7.5935L7.9375 5.17239L8.047 5.04739C8.32363 4.76915 8.4789 4.39274 8.4789 4.00039C8.4789 3.60803 8.32363 3.23163 8.047 2.95339C7.76876 2.67676 7.39235 2.52148 7 2.52148C6.60765 2.52148 6.23124 2.67676 5.953 2.95339H5.9375L1.8905 7.04739L1.875 7.07839L1.8435 7.09389C1.29786 7.81327 1.00172 8.69098 1 9.59389V10.4539C0.998879 10.9918 1.10401 11.5247 1.30936 12.0218C1.51472 12.519 1.81624 12.9708 2.19664 13.3511C2.57703 13.7315 3.0288 14.0329 3.52601 14.2382C4.02322 14.4435 4.55608 14.5486 5.094 14.5474H9C9.8225 14.5474 10.5 13.8694 10.5 13.0474C10.5 12.8344 10.4415 12.6374 10.3595 12.4534C11.0095 12.2894 11.5 11.6979 11.5 11.0004C11.5 10.6174 11.35 10.2659 11.1095 10.0004C11.3594 9.72715 11.4986 9.37066 11.5 9.00039C11.4974 8.82958 11.4656 8.66049 11.406 8.50039H13.5C14.3225 8.50039 15 7.82289 15 7.00039ZM14 7.00039C14 7.27789 13.7775 7.50039 13.5 7.50039H8V8.50039H10C10.2775 8.50039 10.5 8.72289 10.5 9.00039C10.5 9.27789 10.2775 9.50039 10 9.50039H8V10.5004H10C10.2775 10.5004 10.5 10.7229 10.5 11.0004C10.5 11.2779 10.2775 11.5004 10 11.5004H8V12.5474H9C9.2775 12.5474 9.5 12.7699 9.5 13.0474C9.5 13.3249 9.2775 13.5474 9 13.5474H5.0935C3.3615 13.5474 2 12.1859 2 10.4534V9.59439C2 8.86189 2.2615 8.22889 2.6565 7.70339L6.6565 3.65639C6.879 3.43389 7.1215 3.43389 7.344 3.65639C7.5665 3.87939 7.5665 4.12139 7.344 4.34389L5.1875 6.50039H13.5C13.7775 6.50039 14 6.72289 14 7.00039Z"
        fill="white"
      />
    </svg>
  );
};

// const Logo = () => {
//   return (
//     <svg
//       width="150"
//       height="50"
//       viewBox="0 0 150 50"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <rect width="150" height="50" rx="8" fill="white" />
//       <rect
//         x="16"
//         y="24.8281"
//         width="20.9704"
//         height="20.9704"
//         transform="rotate(-45 16 24.8281)"
//         fill="var(--primary-color)"
//       />
//       <path
//         d="M51.7502 18.6272H54.2464L57.2311 24.0247H57.3502L60.3349 18.6272H62.8311L58.3928 26.2766V30.8281H56.1885V26.2766L51.7502 18.6272ZM66.5888 31.0069C65.6952 31.0069 64.9207 30.8103 64.2654 30.4171C63.6101 30.0239 63.1017 29.4738 62.7403 28.7668C62.3828 28.0599 62.2041 27.2338 62.2041 26.2885C62.2041 25.3432 62.3828 24.5152 62.7403 23.8042C63.1017 23.0933 63.6101 22.5412 64.2654 22.148C64.9207 21.7548 65.6952 21.5582 66.5888 21.5582C67.4824 21.5582 68.2569 21.7548 68.9122 22.148C69.5676 22.5412 70.074 23.0933 70.4314 23.8042C70.7928 24.5152 70.9735 25.3432 70.9735 26.2885C70.9735 27.2338 70.7928 28.0599 70.4314 28.7668C70.074 29.4738 69.5676 30.0239 68.9122 30.4171C68.2569 30.8103 67.4824 31.0069 66.5888 31.0069ZM66.6007 29.2792C67.0853 29.2792 67.4904 29.1461 67.8161 28.88C68.1417 28.6099 68.384 28.2485 68.5429 27.7958C68.7057 27.343 68.7871 26.8386 68.7871 26.2825C68.7871 25.7225 68.7057 25.2162 68.5429 24.7634C68.384 24.3066 68.1417 23.9432 67.8161 23.6732C67.4904 23.4031 67.0853 23.2681 66.6007 23.2681C66.1043 23.2681 65.6912 23.4031 65.3616 23.6732C65.0359 23.9432 64.7916 24.3066 64.6288 24.7634C64.4699 25.2162 64.3905 25.7225 64.3905 26.2825C64.3905 26.8386 64.4699 27.343 64.6288 27.7958C64.7916 28.2485 65.0359 28.6099 65.3616 28.88C65.6912 29.1461 66.1043 29.2792 66.6007 29.2792ZM78.6364 26.9796V21.6774H80.793V30.8281H78.7019V29.2017H78.6066C78.4001 29.7141 78.0605 30.1331 77.5879 30.4588C77.1192 30.7844 76.5413 30.9473 75.8542 30.9473C75.2545 30.9473 74.7243 30.8142 74.2636 30.5481C73.8068 30.278 73.4494 29.8868 73.1912 29.3745C72.9331 28.8582 72.804 28.2346 72.804 27.5038V21.6774H74.9606V27.1702C74.9606 27.7501 75.1195 28.2108 75.4372 28.5524C75.7549 28.8939 76.172 29.0647 76.6883 29.0647C77.006 29.0647 77.3138 28.9873 77.6117 28.8324C77.9096 28.6775 78.1538 28.4471 78.3445 28.1413C78.5391 27.8315 78.6364 27.4443 78.6364 26.9796ZM83.0107 30.8281V21.6774H85.1018V23.2025H85.1971C85.3639 22.6743 85.6499 22.2672 86.055 21.9812C86.464 21.6913 86.9307 21.5463 87.455 21.5463C87.5741 21.5463 87.7072 21.5523 87.8541 21.5642C88.0051 21.5721 88.1302 21.5861 88.2295 21.6059V23.5898C88.1381 23.558 87.9931 23.5302 87.7946 23.5064C87.5999 23.4786 87.4113 23.4646 87.2286 23.4646C86.8354 23.4646 86.4819 23.55 86.1682 23.7208C85.8584 23.8876 85.6141 24.12 85.4354 24.4179C85.2567 24.7157 85.1673 25.0593 85.1673 25.4485V30.8281H83.0107ZM93.9189 30.8281V18.6272H96.1291V28.9753H101.503V30.8281H93.9189ZM107.317 31.0069C106.424 31.0069 105.649 30.8103 104.994 30.4171C104.339 30.0239 103.83 29.4738 103.469 28.7668C103.111 28.0599 102.933 27.2338 102.933 26.2885C102.933 25.3432 103.111 24.5152 103.469 23.8042C103.83 23.0933 104.339 22.5412 104.994 22.148C105.649 21.7548 106.424 21.5582 107.317 21.5582C108.211 21.5582 108.985 21.7548 109.641 22.148C110.296 22.5412 110.802 23.0933 111.16 23.8042C111.521 24.5152 111.702 25.3432 111.702 26.2885C111.702 27.2338 111.521 28.0599 111.16 28.7668C110.802 29.4738 110.296 30.0239 109.641 30.4171C108.985 30.8103 108.211 31.0069 107.317 31.0069ZM107.329 29.2792C107.814 29.2792 108.219 29.1461 108.545 28.88C108.87 28.6099 109.112 28.2485 109.271 27.7958C109.434 27.343 109.516 26.8386 109.516 26.2825C109.516 25.7225 109.434 25.2162 109.271 24.7634C109.112 24.3066 108.87 23.9432 108.545 23.6732C108.219 23.4031 107.814 23.2681 107.329 23.2681C106.833 23.2681 106.42 23.4031 106.09 23.6732C105.764 23.9432 105.52 24.3066 105.357 24.7634C105.198 25.2162 105.119 25.7225 105.119 26.2825C105.119 26.8386 105.198 27.343 105.357 27.7958C105.52 28.2485 105.764 28.6099 106.09 28.88C106.42 29.1461 106.833 29.2792 107.329 29.2792ZM117.512 34.4503C116.738 34.4503 116.072 34.345 115.516 34.1345C114.96 33.928 114.513 33.65 114.176 33.3005C113.838 32.951 113.604 32.5637 113.473 32.1388L115.415 31.6681C115.502 31.8469 115.63 32.0236 115.796 32.1984C115.963 32.3771 116.188 32.524 116.47 32.6392C116.755 32.7584 117.115 32.8179 117.548 32.8179C118.159 32.8179 118.666 32.669 119.067 32.3711C119.468 32.0772 119.669 31.5927 119.669 30.9175V29.1839H119.561C119.45 29.4063 119.287 29.6346 119.073 29.869C118.862 30.1033 118.582 30.2999 118.233 30.4588C117.887 30.6176 117.452 30.6971 116.928 30.6971C116.225 30.6971 115.588 30.5322 115.016 30.2026C114.448 29.869 113.995 29.3725 113.658 28.7132C113.324 28.0499 113.157 27.2199 113.157 26.223C113.157 25.2181 113.324 24.3702 113.658 23.6791C113.995 22.9841 114.45 22.4578 115.022 22.1004C115.594 21.739 116.231 21.5582 116.934 21.5582C117.47 21.5582 117.911 21.6496 118.257 21.8323C118.606 22.011 118.884 22.2275 119.091 22.4817C119.297 22.7319 119.454 22.9682 119.561 23.1906H119.681V21.6774H121.807V30.9771C121.807 31.7595 121.621 32.4069 121.247 32.9192C120.874 33.4316 120.364 33.8148 119.716 34.069C119.069 34.3232 118.334 34.4503 117.512 34.4503ZM117.53 29.0051C117.987 29.0051 118.376 28.8939 118.698 28.6715C119.019 28.4491 119.264 28.1294 119.43 27.7124C119.597 27.2953 119.681 26.7949 119.681 26.2111C119.681 25.6352 119.597 25.1308 119.43 24.6979C119.268 24.2649 119.025 23.9293 118.704 23.691C118.386 23.4488 117.995 23.3276 117.53 23.3276C117.049 23.3276 116.648 23.4527 116.327 23.7029C116.005 23.9532 115.763 24.2967 115.6 24.7336C115.437 25.1665 115.355 25.659 115.355 26.2111C115.355 26.7711 115.437 27.2616 115.6 27.6826C115.767 28.0996 116.011 28.4253 116.332 28.6596C116.658 28.89 117.057 29.0051 117.53 29.0051ZM128.009 31.0069C127.116 31.0069 126.341 30.8103 125.686 30.4171C125.03 30.0239 124.522 29.4738 124.161 28.7668C123.803 28.0599 123.624 27.2338 123.624 26.2885C123.624 25.3432 123.803 24.5152 124.161 23.8042C124.522 23.0933 125.03 22.5412 125.686 22.148C126.341 21.7548 127.116 21.5582 128.009 21.5582C128.903 21.5582 129.677 21.7548 130.333 22.148C130.988 22.5412 131.494 23.0933 131.852 23.8042C132.213 24.5152 132.394 25.3432 132.394 26.2885C132.394 27.2338 132.213 28.0599 131.852 28.7668C131.494 29.4738 130.988 30.0239 130.333 30.4171C129.677 30.8103 128.903 31.0069 128.009 31.0069ZM128.021 29.2792C128.506 29.2792 128.911 29.1461 129.236 28.88C129.562 28.6099 129.804 28.2485 129.963 27.7958C130.126 27.343 130.208 26.8386 130.208 26.2825C130.208 25.7225 130.126 25.2162 129.963 24.7634C129.804 24.3066 129.562 23.9432 129.236 23.6732C128.911 23.4031 128.506 23.2681 128.021 23.2681C127.525 23.2681 127.112 23.4031 126.782 23.6732C126.456 23.9432 126.212 24.3066 126.049 24.7634C125.89 25.2162 125.811 25.7225 125.811 26.2825C125.811 26.8386 125.89 27.343 126.049 27.7958C126.212 28.2485 126.456 28.6099 126.782 28.88C127.112 29.1461 127.525 29.2792 128.021 29.2792Z"
//         fill="var(--primary-color)"
//       />
//     </svg>
//   );
// };

// const SmallHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   return <h6 className="font-semibold mb-4 text-base">{children}</h6>;
// };

const BigHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <h5 className="font-semibold text-xl">{children}</h5>;
};

const ItemLink: React.FC<{
  href: string;
  children: React.ReactNode;
  className?: string;
}> = ({ href, children, className }) => {
  return (
    <Link className={`flex gap-2 items-center ${className}`} href={href}>
      <span>
        <ArrowIcon />
      </span>
      <div className="hover:underline">{children}</div>
    </Link>
  );
};

const IconFlex: React.FC<{
  icon: React.ReactNode;
  children: React.ReactNode;
}> = ({ icon, children }) => {
  return (
    <div className="flex hover:underline gap-2">
      <span className="block mt-1">{icon}</span>
      <div className="la">{children}</div>
    </div>
  );
};

const LocationIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 10.832C11.8807 10.832 13 9.71274 13 8.33203C13 6.95132 11.8807 5.83203 10.5 5.83203C9.11929 5.83203 8 6.95132 8 8.33203C8 9.71274 9.11929 10.832 10.5 10.832Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5007 1.66602C8.73254 1.66602 7.03685 2.36839 5.78661 3.61864C4.53636 4.86888 3.83398 6.56457 3.83398 8.33268C3.83398 9.90935 4.16898 10.941 5.08398 12.0827L10.5007 18.3327L15.9173 12.0827C16.8323 10.941 17.1673 9.90935 17.1673 8.33268C17.1673 6.56457 16.4649 4.86888 15.2147 3.61864C13.9645 2.36839 12.2688 1.66602 10.5007 1.66602Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const CallIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66732 2.5C7.08398 2.5 8.75065 6.25 8.75065 6.66667C8.75065 7.5 7.50065 8.33333 7.08398 9.16667C6.66732 10 7.50065 10.8333 8.33398 11.6667C8.65898 11.9917 10.0007 13.3333 10.834 12.9167C11.6673 12.5 12.5007 11.25 13.334 11.25C13.7507 11.25 17.5007 12.9167 17.5007 13.3333C17.5007 15 16.2507 16.25 15.0007 16.6667C13.7507 17.0833 12.9173 17.0833 11.2507 16.6667C9.58398 16.25 8.33398 15.8333 6.25065 13.75C4.16732 11.6667 3.75065 10.4167 3.33398 8.75C2.91732 7.08333 2.91732 6.25 3.33398 5C3.75065 3.75 5.00065 2.5 6.66732 2.5Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const MessageIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83333 7.49935L8.95833 9.99935C9.25394 10.236 9.62132 10.365 10 10.365C10.3787 10.365 10.7461 10.236 11.0417 9.99935L14.1667 7.49935M17.5 14.166V5.83268C17.5 5.39065 17.3244 4.96673 17.0118 4.65417C16.6993 4.34161 16.2754 4.16602 15.8333 4.16602H4.16667C3.72464 4.16602 3.30072 4.34161 2.98816 4.65417C2.67559 4.96673 2.5 5.39065 2.5 5.83268V14.166C2.5 14.608 2.67559 15.032 2.98816 15.3445C3.30072 15.6571 3.72464 15.8327 4.16667 15.8327H15.8333C16.2754 15.8327 16.6993 15.6571 17.0118 15.3445C17.3244 15.032 17.5 14.608 17.5 14.166Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
